import { isFeatureVisibleForCycle } from './isFeatureVisibleForCycle';
export const isFeatureVisible = (feature, productId, paymentCycle) => {
  var _feature$metadata;
  return ((_feature$metadata = feature.metadata) == null ? void 0 : _feature$metadata.hidden) !== 'true' && isFeatureVisibleForCycle(feature, productId, paymentCycle);
};
//# sourceMappingURL=isFeatureVisible.js.map